import script from "./ModalButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalButton.vue?vue&type=script&setup=true&lang=ts"

import "./ModalButton.vue?vue&type=style&index=0&id=14651b84&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14651b84"]])

export default __exports__